import {ApiException} from "@/domain/core/exception/exceptions";
import Vue from "vue";
import {emptyListResponse} from "@/domain/core/utils/django";


const state = {
    event_owners: {...emptyListResponse},
    event_owner: {},
    permissions: {},
    deleteDependencies: null,
}

export const getters = {
    event_owners: state => state.event_owners,
    event_owner: state => state.event_owner,
    permissions: state => state.permissions,
    deleteDependencies: state => state.deleteDependencies,
}


export const mutations = {
    event_owners(state, event_owners) {
        state.event_owners = event_owners
    },
    event_owner(state, event_owner) {
        state.event_owner = event_owner
    },
    deleteEventOwner(state, id) {
        Vue.set(state.event_owners, 'results', state.event_owners.results.filter(event_owner => event_owner.id !== id))
    },
    permissions(state, permissions) {
        state.permissions = permissions
    },
    deleteDependencies(state, dependencies) {
        state.deleteDependencies = dependencies
    }
}


export const actions = service => ({
    async fetchEventOwnerList({commit}, {filters, pagination, sorting}) {
        try {
            const event_owners = await service.fetchEventOwnerList(filters, pagination, sorting)
            commit('event_owners', event_owners)
        } catch (e) {
            if (e instanceof ApiException)
                commit('event_owners', emptyListResponse)
            throw e
        }
    },
    async fetchEventOwner({commit}, id) {
        commit('event_owner', null)
        const event_owner = await service.fetchEventOwner(id)
        commit('event_owner', event_owner)
    },
    async createEventOwner({commit}, data) {
        commit('event_owner', await service.createEventOwner(data))
    },
    async updateEventOwner({commit}, {id, data}) {
        commit('event_owner', await service.updateEventOwner(id, data))
    },
    async deleteEventOwner({commit}, {id, force = false}) {
        const response = await service.deleteEventOwner(id, force)
        commit('deleteEventOwner', id)
        return response
    },
    async checkEventOwnerDependencies({commit}, id) {
        const dependencies = await service.checkEventOwnerDependencies(id)
        commit('deleteDependencies', dependencies)
        return dependencies
    },
})

export default eventOwnerService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(eventOwnerService)
})
